<template>
  <b-modal
    ref="include-imeis-list-modal"
    title="Danh sách IMEI phát sinh"
    size="lg"
  >
    <b-table
      :items="listItems"
      :fields="computedFields"
      bordered
      hover
      show-empty
      :empty-text="'Chưa có IMEI phát sinh nào'"
    >
      <template #head(selected)>
        <b-form-checkbox
          :checked="allSelected"
          :indeterminate="indeterminate"
          @change="toggleSelectAll"
        />
      </template>
      <template #cell(selected)="row">
        <b-form-checkbox
          :checked="isSelected(row.item)"
          @change="toggleSelect(row.item)"
        />
      </template>
      <template #cell(count)="row">
        {{ row.index + 1 }}
      </template>
      <template #cell(imeiCode)="row">
        {{ row.item.imeiCode }}
      </template>
      <template #cell(note)="row">
        {{ row.item.note || '-' }}
      </template>
    </b-table>
    <template #modal-footer>
      <div class="d-flex justify-content-between align-items-center w-100">
        <b-button
          variant="danger"
          size="sm"
          :disabled="!selectedKeys.length"
          @click="handleDeleteSelected"
        >
          <i class="flaticon2-rubbish-bin-delete-button"></i>
          Xóa đã chọn ({{ selectedKeys.length }})
        </b-button>
        <b-button variant="secondary" @click="hideModal">Đóng</b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { convertPrice, makeToastSuccess } from '@/utils/common';
import { convertToDateSlash } from '@/utils/date';
import { showDeleteAlert } from '@/utils/sweet-alert2';

export default {
  name: 'IncludeImeisListModal',
  props: {
    includeImeis: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectedKeys: [],
      fields: [
        {
          key: 'count',
          label: 'STT',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '10%',
          },
          tdClass: 'text-center',
        },
        {
          key: 'imeiCode',
          label: 'Mã IMEI',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '35%',
          },
          tdClass: 'text-left',
        },
        {
          key: 'date',
          label: 'Ngày kích hoạt',
          tdClass: 'text-center',
          thStyle: { fontWeight: 600, color: '#181c32', width: '20%' },
          thClass: 'text-center',
          sortable: true,
          formatter: (value) => {
            return convertToDateSlash(value);
          },
        },
        {
          key: 'unitPrice',
          label: 'Giá nhập',
          tdClass: 'text-center',
          thStyle: { fontWeight: 600, color: '#181c32', width: '20%' },
          thClass: 'text-center',
          formatter: (value) => {
            return convertPrice(value);
          },
        },
        {
          key: 'note',
          label: 'Ghi chú',
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            textAlign: 'center',
            width: '55%',
          },
          tdClass: 'text-left',
        },
      ],
    };
  },
  computed: {
    listItems() {
      if (!Array.isArray(this.includeImeis)) {
        return [];
      }
      return this.includeImeis.filter((item) => item.isValid !== false);
    },
    computedFields() {
      return [
        {
          key: 'selected',
          label: '',
          thStyle: { width: '5%', textAlign: 'center' },
          tdClass: 'text-center',
        },
        ...this.fields,
      ];
    },
    allSelected() {
      return (
        this.listItems.length > 0 &&
        this.selectedKeys.length === this.listItems.length
      );
    },
    indeterminate() {
      return this.selectedKeys.length > 0 && !this.allSelected;
    },
  },
  methods: {
    // Khóa định danh từng IMEI: ưu tiên id (bản ghi đã lưu), nếu không có dùng mã IMEI
    itemKey(item) {
      return item.id != null ? item.id : item.imeiCode;
    },
    isSelected(item) {
      return this.selectedKeys.includes(this.itemKey(item));
    },
    toggleSelect(item) {
      const key = this.itemKey(item);
      const idx = this.selectedKeys.indexOf(key);
      if (idx === -1) {
        this.selectedKeys.push(key);
      } else {
        this.selectedKeys.splice(idx, 1);
      }
    },
    toggleSelectAll(checked) {
      this.selectedKeys = checked
        ? this.listItems.map((item) => this.itemKey(item))
        : [];
    },
    handleDeleteSelected() {
      const count = this.selectedKeys.length;
      if (!count) {
        return;
      }
      showDeleteAlert(
        'Xóa IMEI phát sinh',
        `Bạn có chắc muốn xóa ${count} IMEI đã chọn?`,
        null,
        () => {
          const keys = new Set(this.selectedKeys);
          const remaining = (
            Array.isArray(this.includeImeis) ? this.includeImeis : []
          ).filter((item) => !keys.has(this.itemKey(item)));
          this.$emit('update-include-imeis', remaining);
          this.selectedKeys = [];
          makeToastSuccess(`Đã xóa ${count} IMEI phát sinh`);
        },
      );
    },
    showModal() {
      this.selectedKeys = [];
      this.$refs['include-imeis-list-modal'].show();
    },
    hideModal() {
      this.$refs['include-imeis-list-modal'].hide();
    },
  },
};
</script>
